import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie'; // ✅ Import js-cookie
import { extractDataArray } from './Constants';

const Reports = () => {
  const [reports, setReports] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [filteredReports, setFilteredReports] = useState([]);

  // ✅ Retrieve the logged-in user's college
  const userCollege = Cookies.get('college') || 'main';

  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    // Aliases to handle different spellings or acronyms stored in the database
    const aliases = {
      'hrc': ['hrc', 'hansraj'],
      'rjc': ['rjc', 'ramjas'],
      'jcbust': ['jcbust', 'jc bose', 'j.c. bose', 'jcbose', 'jc bose ust'],
      'clc': ['clc', 'campus law'],
      'nitp': ['nitp', 'nit patna'],
      'cu': ['cu', 'chandigarh university'],
      'pu': ['pu', 'panjab university', 'punjab'],
      'lpu': ['lpu', 'lovely professional'],
      'fot': ['fot', 'faculty of technology'],
      'cic': ['cic', 'cluster innovation'],
      'kmc': ['kmc', 'kirorimal', 'kirori mal'],
      'mhc': ['mhc', 'miranda house'],
      'drc': ['drc', 'daulat ram']
    };

    const adminCollege = String(userCollege).toLowerCase();
    const validTerms = aliases[adminCollege] || [adminCollege];

    // Filter by both College and Search Text
    const filtered = reports.filter((report) => {
      // 1. Check if the user is allowed to see this report
      let isAllowed = false;
      if (userCollege === 'main') {
        isAllowed = true; // Main admin sees all
      } else {
        const reportArea = String(report.area || '').toLowerCase();
        isAllowed = validTerms.some(term => 
          // Strict match for short acronyms, loose match for full names
          term.length <= 2 ? reportArea.split(/[\s,]+/).includes(term) : reportArea.includes(term)
        );
      }

      // If they aren't allowed, don't show it (skip search check)
      if (!isAllowed) return false;

      // 2. Check if it matches the typed search text
      const matchesSearch = 
        (report.event_name && report.event_name.toLowerCase().includes(searchText.toLowerCase())) ||
        (report.area && report.area.toLowerCase().includes(searchText.toLowerCase()));

      return matchesSearch;
    });

    setFilteredReports(filtered);
  }, [searchText, reports]); // React will re-run this anytime search text or backend reports update

  const fetchReports = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/reports/read`);
      const data = await res.json();
      setReports(extractDataArray(data));
      // Removed setFilteredReports(data) from here because the useEffect above handles it automatically
    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };

  return (
    <div className="main-activities-container">
      <div className="premium-report-card">

        <div className="premium-report-header">
          <h1 className="header-title">Reports</h1>

          <div className="search-wrapper">
            <input
              type="text"
              className="premium-search-input"
              placeholder="Search reports..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>

        <div className="premium-table-container">
          <table className="premium-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Report Date</th>
                <th>Event Name</th>
                <th>Area</th>
                <th className="action-column">PDF</th>
              </tr>
            </thead>

            <tbody>
              {filteredReports.length > 0 ? (
                filteredReports.map((report) => (
                  <tr
                    key={report.id}
                    className={report.isShown === '0' || report.isShown === 0 ? 'row-hidden' : ''}
                  >
                    <td className="index-cell">{report.id}</td>
                    <td>{report.report_date}</td>
                    <td className="fw-500">{report.event_name}</td>
                    <td>{report.area}</td>

                    <td className="action-column">
                      <a
                        href={`https://ethiccraft.org/${report.pdf_link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="premium-btn btn-secondary"
                      >
                        View PDF
                      </a>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="empty-state">
                    No reports found.
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

      </div>
    </div>
  );
};

export default Reports;